import DrawerButtons from './DrawerButtons';

interface OwnProps {
    isSaving?: boolean;
    isFormDirty?: boolean;
    onSubmitAction?: () => void;
    onCancelAction: () => void;
    /** Red delete next to Save; confirm dialog + async action (e.g. match drawer from table). */
    onDeleteAction?: () => Promise<void>;
    deleteConfirmMessage?: string;
}

export type Props = OwnProps;

export default DrawerButtons;
